import { RequeteurDomaineEnum } from '../../dto/GenApi.iNotPaie.Dto/RequeteurDomaineEnum';

export const domainesRequeteur = [
	{
		Code: RequeteurDomaineEnum.Salarie,
		Name: 'Salarié',
		Check: false,
		State: true,
		Counter: 0
	},
	{
		Code: RequeteurDomaineEnum.Contrat,
		Name: 'Contrat',
		Check: false,
		State: true,
		Counter: 0
	},
	{
		Code: RequeteurDomaineEnum.Bulletin,
		Name: 'Bulletin',
		Check: false,
		State: true,
		Counter: 0
	},
	{
		Code: RequeteurDomaineEnum.Reglement,
		Name: 'Règlement',
		Check: false,
		State: true,
		Counter: 0
	},
	{
		Code: RequeteurDomaineEnum.Absence,
		Name: 'Absence',
		Check: false,
		State: true,
		Counter: 0
	}
];



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/requeteurListeDomaine.ts